import { useTripBuilderQuote } from "../context/TripBuilderQuoteStepContext";
import { useTripBuilder } from "../context/TripBuilderContext";
import { getCurrency } from "../../../../hooks";
import currency from "currency.js";

export const useExtensionPrices = () => {
    const { departure } = useTripBuilder();
    const { draftQuote } = useTripBuilderQuote();
    const { price } = getCurrency();
    const extension = departure?.activeExtension;
    const allTrips = draftQuote?.order.trips ?? [];

    const getTrip = (tripId?: string) =>
        allTrips.find((trip) =>
            tripId ? trip._id === tripId : trip.isPrimary,
        );

    const getExtensionSalePrice = (tripId?: string) => {
        if (!extension) {
            return { extensionSalePrice: null, appliedToTrip: false };
        }
        const trip = getTrip(tripId);
        const extensionOffer =
            trip?.extensionOffer?.extension.lineItemCode ===
            extension.lineItemCode
                ? trip.extensionOffer
                : undefined;

        return {
            extensionSalePrice:
                extensionOffer?.salePrice?.value ??
                price(extension.price.value).value,
            appliedToTrip: extensionOffer?.appliedToTrip ?? false,
        };
    };

    const getAllExtensionSalePrices = () => {
        if (!extension) {
            return [];
        }

        return allTrips.map(
            (trip) => getExtensionSalePrice(trip._id).extensionSalePrice,
        );
    };

    const getTotalExtensionSalePrice = () => {
        if (!extension) {
            return null;
        }

        return getAllExtensionSalePrices().reduce(
            (acc, salePrice) =>
                acc.add(salePrice ?? price(extension.price.value).value),
            currency(0),
        ).value;
    };

    return {
        getExtensionSalePrice,
        getAllExtensionSalePrices,
        getTotalExtensionSalePrice,
    };
};
